import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * On route change, scrolls so the header is in view (window + header scrollIntoView after paint).
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    if (document.documentElement.scrollTop) document.documentElement.scrollTop = 0
    if (document.body.scrollTop) document.body.scrollTop = 0
    const id = requestAnimationFrame(() => {
      document.querySelector('header')?.scrollIntoView({ block: 'start', behavior: 'auto' })
    })
    return () => cancelAnimationFrame(id)
  }, [pathname])

  return null
}

export default ScrollToTop
